import { useEffect } from 'react'
import { trackInternalEvent } from '@rio/tracking'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'

import { InfoBox, SuccessBox } from '../..'
import { WidgetProps } from '../../widget.types'
import { WidgetTheme } from '../../WidgetTheme'
import { WidgetBox, WidgetContainer } from '../../widget.styles'

import { useThemeConfig } from '../../hooks/useThemeConfig'
import { useClCraftingConfig } from './hooks/useClCraftingConfig'
import { useClCraftingActions } from './hooks/useClCraftingActions'

import * as Styles from './styles'
import CoverLetterCraftingImage from './assets/ilustration.png'
import CoverLetterCraftingMobileImage from './assets/ilustration-mobile.png'

export const CoverLetterCrafting = ({ service }: WidgetProps) => {
  const { isPhone } = useMediaQueries()
  const theme = useThemeConfig({ service })
  const { text, status } = useClCraftingConfig(service)
  const { handleCreateCl, handleCompletedClick } = useClCraftingActions(service)

  const isCompleted = status === 'completed'
  const src = isPhone ? CoverLetterCraftingMobileImage : CoverLetterCraftingImage

  const handleClick = () => {
    trackInternalEvent('progress_cta_click', {
      score: service.title,
      cta: text.actionText,
    })
    if (status === 'completed') return handleCompletedClick()
    handleCreateCl()
  }

  useEffect(() => {
    if (isCompleted) {
      trackInternalEvent('progress_score_completed', { score: service.title })
    }
  }, [isCompleted, service.title])

  return (
    <WidgetTheme theme={theme[status]} tipOrder={service.widgetTipOrder}>
      <WidgetContainer>
        <WidgetBox>
          <InfoBox
            isCompleted={isCompleted}
            text={text}
            handleClick={handleClick}
            data-testid={`cover-letter-crafting-info-${status}`}
            actionButtonTestId={`cover-letter-crafting-action-button-${status}`}
          />
        </WidgetBox>
        <WidgetBox>
          {isCompleted ? (
            <SuccessBox />
          ) : (
            <Styles.Image
              src={src}
              data-testid={`cover-letter-crafting-illustration-box-${status}`}
            />
          )}
        </WidgetBox>
      </WidgetContainer>
    </WidgetTheme>
  )
}
